var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.47 58.12l-26.3-45.74a11.56 11.56 0 00-9.86-5.88H37.7a11.55 11.55 0 00-9.86 5.88L1.53 58a11.48 11.48 0 000 11.44l26.3 46a11.77 11.77 0 009.86 6.09H90.3a11.73 11.73 0 009.87-6.06l26.3-45.74a11.73 11.73 0 000-11.61z",
    fill: "#4285f4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.49 50.55l-36.18 3.33-7 7 6 6-5.95 10.42 44.2 44.2h3.74a11.73 11.73 0 009.87-6.06l18.33-31.88z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.07
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7 50.27H43.26A1.22 1.22 0 0042 51.48v8.57a1.21 1.21 0 001.21 1.21H84.7a1.22 1.22 0 001.21-1.21v-8.57a1.22 1.22 0 00-1.21-1.21m-6.41 8a2.48 2.48 0 112.48-2.48 2.48 2.48 0 01-2.48 2.48M84.7 66.74H43.26A1.22 1.22 0 0042 68v8.57a1.22 1.22 0 001.21 1.21H84.7a1.22 1.22 0 001.21-1.21v-8.62a1.22 1.22 0 00-1.21-1.21m-6.41 8a2.48 2.48 0 112.48-2.48 2.48 2.48 0 01-2.48 2.48"
  }))));
}

export default SvgIcon;